import React from "react";
import type { CardBrand } from "@meupedaco/shared";
import { CrudPage } from "../../components/CrudPage";

export const CardBrandsPage: React.FC = () => {
  return (
    <CrudPage<CardBrand>
      title="Bandeiras de Cartão"
      endpoint="/modules/card-brands"
      searchPlaceholder="Buscar por nome..."
      columns={[
        { label: "Nome", render: (item) => item.name },
        { label: "Ativa", render: (item) => (item.isActive ? "Sim" : "Não") },
      ]}
      formFields={[
        { name: "name", label: "Nome", type: "text", required: true },
        { name: "isActive", label: "Ativa", type: "checkbox" },
      ]}
      initialValues={{
        name: "",
        isActive: true,
      }}
      mapToPayload={(values) => ({
        name: values.name,
        isActive: values.isActive,
      })}
      permissionWrite="CATALOG_CARD_BRANDS_WRITE"
    />
  );
};
